import React, { useState, useEffect } from "react";
import Dropdown from "./Dropdown";
import WorkspaceSelector from "../Helper/WorkspaceSelector";
import Text from "./Text";
import { useWebSocket } from "../Context/WebSocketContext";
import { getUser } from "../Helper/workspaceStorage";
import { emitWorkspaceChange } from "../db/workspaceEvents";

const WorkspaceSwitch = () => {
    const { isOnline } = useWebSocket();
    const [options, setOptions] = useState([]);
    const { setCurrentWorkspace, currentWorkspace, getFullCurrentWorkspace } = WorkspaceSelector()
    const [selected, setSelected] = useState("");

    useEffect(() => {
        const user = getUser();
        if (user && Array.isArray(user.workspace)) {
            setSelected(currentWorkspace)
            const mappedOptions = user.workspace.map((workspace, index) => ({
                value: index,
                label: workspace.workspaceDTO?.name || `Workspace ${index + 1}`,
            }));
            setOptions(mappedOptions);
        }
    }, []);

    const changeWorkspace = (index) => {
        setCurrentWorkspace(index)
        setSelected(currentWorkspace)
        emitWorkspaceChange(index)
    }

    const getCurrentLogo = () => {
        const ws = getFullCurrentWorkspace()
        return ws ? ws.workspaceDTO.logo : null
    }

    return (
        <>
            {options.length > 0 ? isOnline ? (
                <div className="flex w-fit">
                    {getCurrentLogo() && <img src={getCurrentLogo()} alt="Logo" className="w-10 h-10 object-cover rounded-md mr-2" />}
                    <Dropdown
                        options={options}
                        value={selected}
                        onChange={changeWorkspace}
                    />
                </div>

            ) : (<Text type="itemtext">{`${getFullCurrentWorkspace()?.workspaceDTO?.name}`}</Text>) : (<Text type="itemtext">{`Kein Workspace`}</Text>)}
        </>
    );
};

export default WorkspaceSwitch;
